import client from './client';
import type { Payment } from '../types/payment';

interface CreatePaymentResponse {
  paymentId: string;
  confirmationUrl: string;
}

export async function createPayment(
  planId: string,
  returnUrl: string,
  promocode?: string
): Promise<CreatePaymentResponse> {
  const body: { planId: string; returnUrl: string; promocode?: string } = {
    planId,
    returnUrl,
  };
  if (promocode) {
    body.promocode = promocode;
  }
  const { data } = await client.post('/payments', body);
  return data;
}

/**
 * Оплата дополнительного ключа для текущей активной подписки.
 * 409 — нет активной подписки, 422 — докупка недоступна / промокод не применим.
 */
export async function createKeyPayment(
  returnUrl: string,
  promocode?: string
): Promise<CreatePaymentResponse> {
  const body: { returnUrl: string; promocode?: string } = { returnUrl };
  if (promocode) {
    body.promocode = promocode;
  }
  const { data } = await client.post('/payments/key', body);
  return data;
}

/**
 * Докупка трафика для обхода белых списков — пакет в ГБ из /cdn/packages.
 * 403 — нет активной платной подписки, 422 — неизвестный пакет / промокод не применим.
 */
export async function createCdnTopupPayment(
  packageGb: number,
  returnUrl: string,
  promocode?: string
): Promise<CreatePaymentResponse> {
  const body: { packageGb: number; returnUrl: string; promocode?: string } = {
    packageGb,
    returnUrl,
  };
  if (promocode) {
    body.promocode = promocode;
  }
  const { data } = await client.post('/payments/cdn-topup', body);
  return data;
}

export async function getPaymentStatus(paymentId: string): Promise<Payment> {
  const { data } = await client.get(`/payments/${paymentId}/status`);
  return data;
}

export async function getPaymentHistory(): Promise<Payment[]> {
  const { data } = await client.get('/payments/history');
  return data || [];
}
